import React, { Component } from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';
import RcInputNumber from '../rc-components/input-number';
import Input from '../input/Input';
import { Size } from '../_util/enum';
import ConfigContext from '../config-provider/ConfigContext';
export function formatNumber(value) {
    const vs = String(value).split('.');
    const v = vs[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return vs.length > 1 ? `${v}.${vs[1]}` : v;
}
export function parseNumber(value) {
    if (value.indexOf(',') !== -1) {
        return value.replace(/,/g, '');
    }
    return value;
}
function renderInput(props) {
    return React.createElement(Input, Object.assign({}, props));
}
export default class InputNumber extends Component {
    constructor() {
        super(...arguments);
        this.numberFormatter = (value) => {
            const { formatter } = this.props;
            const v = formatNumber(value);
            return formatter ? formatter(v) : v;
        };
        this.numberParser = (value) => {
            const { parser } = this.props;
            const v = parseNumber(value);
            return parser ? parser(v) : v;
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    render() {
        const { allowThousandth = false, className, size, prefixCls: customizePrefixCls, ...others } = this.props;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('input-number', customizePrefixCls);
        const inputNumberClass = classNames({
            [`${prefixCls}-lg`]: size === Size.large,
            [`${prefixCls}-sm`]: size === Size.small,
        }, className);
        let otherProp = others;
        if (allowThousandth) {
            otherProp = {
                ...otherProp,
                formatter: this.numberFormatter,
                parser: this.numberParser,
            };
        }
        return (React.createElement(RcInputNumber, Object.assign({ ref: (c) => (this.inputNumberRef = c), className: inputNumberClass, prefixCls: prefixCls, renderInput: renderInput }, omit(otherProp, ['form']))));
    }
    focus() {
        this.inputNumberRef.focus();
    }
    blur() {
        this.inputNumberRef.blur();
    }
}
InputNumber.displayName = 'InputNumber';
InputNumber.defaultProps = {
    step: 1,
};
